export const lang = {
	//title為每個頁面的標題
	title: '組合套餐',
}
